export const modularHousesNavItems = {
  model: 'Modelo 3D',
  options: 'Opciones',
};

export const description =
  'Las casas modulares ofrecen un diseño inusual y una vida cómoda para su familia. La acogedora Cáceres, el romántico Toledo o la dinámica Barcelona, este tipo de alojamiento encaja fácilmente en cualquier paisaje. Producimos edificios modulares modernos, energéticamente eficientes y prefabricados. Su vivienda, completamente preparada para la residencia permanente, tendrá en cuenta todas sus necesidades. Se le da la oportunidad de elegir la opción con un acabado interior llave en mano.';